export default "__VITE_ASSET__nVbyJFWZ__"